/* Averso — une seule offre dans le panier (bug signalé le 18/10/2026 : « choisir l'offre 1 affiche l'offre 3 »).
   Cause : le panier gardait l'offre choisie avant. Ex. : 2 achetés = 1 offert au panier (3 parapluies + 3 étuis offerts),
   le client revient, choisit « 1 acheté » → 4 parapluies, remise « 2 ACHETÉS = 1 OFFERT » et étuis toujours là.
   Correctif : quand le bouton « In den Warenkorb » envoie des parapluies principaux (produit parapluie), les lignes
   parapluie déjà au panier sont retirées JUSTE AVANT l'ajout, et le lot d'étuis offerts aussi si la nouvelle offre fait
   moins de 3 parapluies. Le panier montre donc exactement l'offre choisie. Andere Schirme ajouts (upsell −50 %, étui payant,
   cadeau) ne sont pas touchés. */
(function () {
  if (window.__aversoOffreUnique) return;
  window.__aversoOffreUnique = true;

  var MAIN = 'parapluie', GIFT = 'etuis-offerts', GIFT_MIN = 3;
  var GIFT1 = 'etui-offert', GIFT1_Q = 2;   // offre 1 acheté = 1 offert : 1 étui offert avec exactement 2 parapluies (25/10/2026)
  var F = window.fetch.bind(window);
  var ADD = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var ids = null;

  function racine() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function urlDe(x) { return String((x && x.url) || x || '').split('#')[0]; }

  // ids des variantes du parapluie principal : JSON des offres sur la fiche produit, sinon /products/parapluie.js
  function idsPrincipal() {
    if (ids) return Promise.resolve(ids);
    try {
      var el = document.querySelector('quantity-breaks script[type="application/json"]');
      if (el) {
        ids = JSON.parse(el.textContent).map(function (v) { return String(v.id); });
        if (ids.length) return Promise.resolve(ids);
      }
    } catch (e) {}
    return F(racine() + 'products/' + MAIN + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { ids = (p.variants || []).map(function (v) { return String(v.id); }); return ids; });
  }

  // lignes demandées par l'ajout : [{id, quantity}] (FormData, texte url-encodé ou JSON)
  function lignes(body) {
    var paires = [], out = {}, i;
    try {
      if (body && typeof body.entries === 'function' && !(body instanceof URLSearchParams)) {
        var it = body.entries(), n;
        while (!(n = it.next()).done) paires.push([n.value[0], String(n.value[1])]);
      } else if (typeof body === 'string' || body instanceof URLSearchParams) {
        var s = String(body);
        try {
          var j = JSON.parse(s);
          if (j && j.items) return j.items.map(function (x) { return { id: String(x.id), quantity: Number(x.quantity) || 1 }; });
          if (j && j.id) return [{ id: String(j.id), quantity: Number(j.quantity) || 1 }];
          return [];
        } catch (e) {
          new URLSearchParams(s).forEach(function (v, k) { paires.push([k, v]); });
        }
      }
    } catch (e) { return []; }
    for (i = 0; i < paires.length; i++) {
      var k = paires[i][0], v = paires[i][1], m = k.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (m) { out[m[1]] = out[m[1]] || {}; out[m[1]][m[2]] = v; }
      else if (k === 'id' || k === 'quantity') { out.solo = out.solo || {}; out.solo[k] = v; }
    }
    return Object.keys(out).filter(function (x) { return out[x].id; })
      .map(function (x) { return { id: String(out[x].id), quantity: Number(out[x].quantity) || 1 }; });
  }

  function lireCart() {
    return F(racine() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function maj(updates, rendre) {
    var body = { updates: updates };
    if (rendre) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
    return F(racine() + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // tiroir redessiné après une correction faite après coup (la page panier, elle, est rechargée)
  function afficher(c) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var items = document.querySelector('cart-drawer-items'), drawer = document.querySelector('cart-drawer');
    try {
      if (items && items.renderSectionsFromCartData && c.sections) items.renderSectionsFromCartData(c);
      if (drawer) drawer.classList.toggle('is-empty', c.item_count === 0);
    } catch (e) {}
  }

  // avant l'ajout d'une offre : retire l'offre précédente
  function viderOffre(qMain) {
    return lireCart().then(function (cart) {
      var up = {}, n = 0;
      (cart.items || []).forEach(function (it) {
        if (it.handle === MAIN || (it.handle === GIFT && qMain < GIFT_MIN) || (it.handle === GIFT1 && qMain !== GIFT1_Q)) { up[it.key] = 0; n++; }
      });
      return n ? maj(up) : null;
    });
  }

  // après l'ajout : 1 seul lot d'étuis offerts, et seulement avec 3 parapluies ou plus
  function normaliserCadeau(qMain) {
    return lireCart().then(function (cart) {
      var up = {}, n = 0, garde = qMain >= GIFT_MIN ? 1 : 0, garde1 = qMain === GIFT1_Q ? 1 : 0;
      (cart.items || []).forEach(function (it) {
        if (it.handle !== GIFT && it.handle !== GIFT1) return;
        var q = Math.min(it.quantity, it.handle === GIFT ? garde : garde1);
        if (it.handle === GIFT) garde -= q; else garde1 -= q;
        if (q !== it.quantity) { up[it.key] = q; n++; }
      });
      if (!n) return null;
      return maj(up, true).then(function (r) { return r.json(); }).then(afficher);
    });
  }

  window.fetch = function (input, init) {
    var url = urlDe(input);
    if (!ADD.test(url) || !init || !init.body) return F(input, init);
    var demande = lignes(init.body);
    if (!demande.length) return F(input, init);
    return idsPrincipal().then(function (principal) {
      var qMain = 0;
      demande.forEach(function (l) { if (principal.indexOf(l.id) > -1) qMain += l.quantity; });
      if (!qMain) return F(input, init);
      return viderOffre(qMain)
        .catch(function () {})
        .then(function () { return F(input, init); })
        .then(function (res) {
          setTimeout(function () { normaliserCadeau(qMain).catch(function () {}); }, 1500);
          return res;
        });
    }, function () { return F(input, init); });
  };
})();
